<template>
  <div class="relative flex py-10 items-center">
    <div class="grow border-t border-slate-200 dark:border-slate-700" />
    <span class="shrink mx-4 select-none text-slate-500 text-sm">
      <slot />
    </span>
    <div class="grow border-t border-slate-200 dark:border-slate-700" />
  </div>
</template>
